import React, { Suspense, lazy } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import { HomeSkeleton } from "./components/Skeleton/Skeleton";

// Lazy loaded page components
const Home = lazy(() => import("./pages/Home/Home"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const NoticeBoard = lazy(() => import("./pages/NoticeBoard/NoticeBoard"));
const Coming = lazy(() => import("./pages/Coming/Coming"));
const Courses = lazy(() => import("./pages/Courses/Courses"));
const AboutUs = lazy(() => import("./pages/About/AboutUs"));
const Results = lazy(() => import("./pages/Results/Results"));
const Campus = lazy(() => import("./pages/Campus/Campus"));
const Tenders = lazy(() => import("./pages/Tenders/Tenders"));
const Fee = lazy(() => import("./pages/Fee/Fee"));
const Faculty = lazy(() => import("./pages/Faculty/Faculty"));
const Ignou = lazy(() => import("./pages/Ignou/Ignou"));
const PastPrincipals = lazy(() => import("./pages/PastPrincipals/PastPrincipals"));
const AdministrativeStaff = lazy(() => import("./pages/AdministrativeStaff/AdministrativeStaff"));
const Rti = lazy(() => import("./pages/Rti/Rti"));
const Admissions = lazy(() => import("./pages/Admissions/Admissions"));
const Events = lazy(() => import("./pages/Events/Events"));
const Committee = lazy(() => import("./pages/Committee/Committee"));

function App() {
  return (
    <Layout>
      <Suspense fallback={<HomeSkeleton />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/notice-board" element={<NoticeBoard />} />
          <Route path="/coming" element={<Coming />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/results" element={<Results />} />
          <Route path="/campus" element={<Campus />} />
          <Route path="/tenders" element={<Tenders />} />
          <Route path="/fee" element={<Fee />} />
          <Route path="/faculty" element={<Faculty />} />
          <Route path="/ignou" element={<Ignou />} />
          <Route path="/pastprincipals" element={<PastPrincipals />} />
          <Route path="/administrativestaff" element={<AdministrativeStaff />} />
          <Route path="/rti" element={<Rti />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/events" element={<Events />} />
          <Route path="/committee" element={<Committee />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default App;
